import { useQuery } from 'data-fetching-client';
import getIn from 'immutable-less/transmute/getIn';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import { GET_OBJECT_TYPE_BY_ID } from 'automation-ui-references/object-type-properties/ObjectTypesQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const EventTypeLabelFromSegmentationFilters = ({
  eventTypeId
}) => {
  const {
    loading,
    data,
    error
  } = useQuery(GET_OBJECT_TYPE_BY_ID, {
    skip: !eventTypeId,
    variables: {
      objectTypeId: `${eventTypeId.metaType}-${eventTypeId.innerId}`
    }
  });
  if (loading) {
    return /*#__PURE__*/_jsx(SkeletonText, {});
  }
  const singularForm = getIn(['objectTypeById', 'singularForm'], data);
  if (error || !singularForm) {
    return /*#__PURE__*/_jsx(MissingLabel, {
      type: "event"
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: singularForm
  });
};
export default EventTypeLabelFromSegmentationFilters;